import { QueryCache, QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 2,
        },
    },
    /**
     * Global error handler for all queries
     */
    queryCache: new QueryCache({
        onError: (error): void => {
            console.error(error);
        },
    }),
});
